<div class="container-fluid " style="background-color: #d0d0d0">
    <div class="container">
        <div class="row">
            <!-- Login Left -->
            <div class="login-left col-md-5 align-self-center">
                <div class="primary" *ngIf="!isSubmit">
                    <h3>Resend Password</h3>
                    <p>If you haven’t received your activation email. Enter your email below and we’ll send you another.</p>
                    <!-- Form Section -->
                    <form (ngSubmit)="resendForm()" [formGroup]="form">


                        <div class="form-group">
                            <div class="errorHandler" [ngClass]="{ 'is-invalid': submitted && f.resendEmail.errors }">
                                <input id="EmailAddress" formControlName="resendEmail" type="email" required class="form-control">

                                <label for="EmailAddress">Enter Your Email</label>
                            </div>
                            <div *ngIf="submitted && f.resendEmail.errors" class="invalid-feedback">
                                <div *ngIf="f.resendEmail.errors.required">Email is required</div>
                                <div *ngIf="f.resendEmail.errors.email">Email must be a valid email address</div>
                            </div>
                            <div *ngIf="isError !== ''" class="invalid-feedback">
                              {{isError}}
                            </div>
                        </div>
                        <button type="submit" class="btn btn-default">Send</button>
                        <a [routerLink]="['/login']">Login</a>
                    </form>
                </div>

                <div class="secondary" *ngIf="isSubmit">
                    <h3>We have resent an Email :)</h3>
                    <p>Password reset instructions have been emailed to you. Be sure to check your spam folder.</p>
                    <a [routerLink]="['/login']" class="">Go Back to Login</a>
                </div>


            </div>
            <!-- Login Right -->
            <div class="login-right col-xl-7 col-sm-6 d-none d-md-block  " style="background-image: url('assets/images/minneapolis-skyline.jpg')">
            </div>   
        </div>
    </div>
</div>
